export default __webpack_public_path__ + "static/media/midasi_entry_zh_cn_sp.e01530fd.png";